import type { ComponentProps } from 'react'

const sizes = {
  // 42/51 bold on desktop, 28/34 on mobile.
  lg: 'text-[28px] leading-[34px] font-bold md:text-[42px] md:leading-[51px]',
  // Headings inside content pages (core values, veganism): 40/40 extrabold on
  // desktop, 32/36 on mobile.
  md: 'text-[32px] leading-9 font-extrabold md:text-[40px] md:leading-[40px]',
}

/** Standard h2. Margins come from the caller. */
export function SectionHeading({
  className = '',
  tone = 'black',
  size = 'lg',
  ...props
}: ComponentProps<'h2'> & {
  tone?: 'black' | 'white'
  size?: keyof typeof sizes
}) {
  return (
    <h2
      className={`${sizes[size]} ${tone === 'white' ? 'text-white' : 'text-fg'} ${className}`}
      {...props}
    />
  )
}
